import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { buildSidebarData } from './SidebarData';
import './sideBar.scss'
import { BsCaretDownFill, BsCaretUpFill, BsPersonCircle } from 'react-icons/bs';
import { getLocalStorageData } from '../../utils/LocalStorageService';
import ForgotResetPassword from '../../pages/auth/ForgotResetPassword';
import { PAGE_TITLE } from '../../constant/reportType';
import { useFindAllGroupedLibraryCategoriesMutation, useFindAllLibraryCategoriesMutation, useGetAllLibraryCategoriesMutation } from '../../redux-toolkit/services/libraryCategoriesService';
import { alertMessage } from '../../utils/AlertService';
import { useDispatch } from 'react-redux';
import { getAllLibraryCategoriesDetails, getGroupedLibraryCategories, setAllLibraryCategories, setGroupedLibraryCategories } from '../../redux-toolkit/slices/libraryCategorySlice';
import { useAppSelector } from '../../redux-toolkit/hooks';
import { LuLibraryBig } from 'react-icons/lu';

type Props = {
    isOpen: boolean
};

const Sidebar = (props: Props) => {

    const localStorageObj: any = getLocalStorageData("localUser");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    //state
    const [open, setOpen] = useState<Record<string, boolean>>({});
    const [resetPasswordShow, setResetPasswordShow] = useState(false);
    const [sidebarData, setSidebarData] = useState<any[]>([]);


    const [findAllGroupedLibraryCategories, findAllGroupedLibraryCategoriesResponse] = useFindAllGroupedLibraryCategoriesMutation();

    const userType = (localStorageObj?.userType || "").toLowerCase();
    const groupedData: any = useAppSelector(getGroupedLibraryCategories);


    useEffect(() => {
        findAllGroupedLibraryCategories({})
    }, []);

    useEffect(() => {
        if (findAllGroupedLibraryCategoriesResponse.isSuccess) {
            dispatch(setGroupedLibraryCategories(findAllGroupedLibraryCategoriesResponse.data));
        }
        else if (findAllGroupedLibraryCategoriesResponse.isError) {
            let response: any = findAllGroupedLibraryCategoriesResponse?.error;
            alertMessage(response, "error");
        }

    }, [findAllGroupedLibraryCategoriesResponse]);


    useEffect(() => {
        if (groupedData) {
            setSidebarData(buildSidebarData(groupedData));
        }
    }, [groupedData]);

    const filteredSidebarData = sidebarData
        .filter(item => {
            return !item.roles || item.roles.some((role: string) => role.toLowerCase() === userType.toLowerCase());
        })
        .map(item => {
            if (item.subNav) {
                return {
                    ...item,
                    subNav: item.subNav.filter((subItem: any) =>
                        !subItem.roles || subItem.roles.some((role: any) => role.toLowerCase() === userType.toLowerCase())
                    ),
                };
            }
            return item;
        });

        console.log(filteredSidebarData ,"filteredSidebarData");

    const toggleSubNav = (index: any) => {
        setOpen({ ...open, [index]: !open[index] });
    }

    const handleLogOut = () => {
        navigate("/logout");
    };

    const handleResetClick = () => setResetPasswordShow(true);


    return (
        <>
            <div className={`sidebar ${props.isOpen ? 'open' : 'closed'} shadow-sm vh-100`}>
                <Nav defaultActiveKey="/home" className="flex-column">
                    {filteredSidebarData.map((item, index) => (
                        <Nav.Item key={index}>
                            {item.subNav ? (
                                <>
                                    <Nav.Link
                                        className="d-flex align-items-center justify-content-between"
                                        onClick={() => toggleSubNav(index)}
                                    >
                                        <div className="text d-flex align-items-center">
                                            <span className="text-primary">{item.icon}</span>
                                            <span className={`ps-2 cm-text-color ${props.isOpen ? '' : 'd-none'}`}>
                                                {item.title}
                                            </span>
                                        </div>
                                        <span className="text-primary">
                                            {open[index] ? <BsCaretUpFill /> : <BsCaretDownFill />}
                                        </span>
                                    </Nav.Link>

                                    {open[index] && (
                                        <Nav className="flex-column ms-3">
                                            {item.subNav.map((subItem: any, subIndex: any) => (
                                                <div key={subIndex}>
                                                    {subItem.subNav ? (
                                                        <>
                                                            <Nav.Link
                                                                className="d-flex align-items-center justify-content-between"
                                                                onClick={() => toggleSubNav(`${index}-${subIndex}`)}
                                                            >
                                                                <div className="text d-flex align-items-center">
                                                                    <span className="text-primary">{subItem.icon}</span>
                                                                    <span className={`ps-2 cm-text-color ${props.isOpen ? '' : 'd-none'}`}>
                                                                        {subItem.title}
                                                                    </span>
                                                                </div>
                                                                <span className="text-primary">
                                                                    {open[`${index}-${subIndex}`] ? <BsCaretUpFill /> : <BsCaretDownFill />}
                                                                </span>
                                                            </Nav.Link>

                                                            {open[`${index}-${subIndex}`] && (
                                                                <Nav className="flex-column ms-4">
                                                                    {subItem.subNav.map((langItem: any, langIndex: any) => (
                                                                        <Nav.Link as={Link} to={langItem.path} key={langIndex}>
                                                                            <span className="text-primary">{langItem.icon}</span>
                                                                            <span className={`ps-2 cm-text-color ${props.isOpen ? '' : 'd-none'}`}>
                                                                                {langItem.title}
                                                                            </span>
                                                                        </Nav.Link>
                                                                    ))}
                                                                </Nav>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <Nav.Link as={Link} to={subItem.path}>
                                                            <span className="text-primary">{subItem.icon}</span>
                                                            <span className={`ps-2 cm-text-color ${props.isOpen ? '' : 'd-none'}`}>
                                                                {subItem.title}
                                                            </span>
                                                        </Nav.Link>
                                                    )}
                                                </div>
                                            ))}
                                        </Nav>
                                    )}
                                </>
                            ) : (
                                <Nav.Link className="d-flex align-items-center" as={Link} to={item.path}>
                                    <span className="text-primary">{item.icon}</span>
                                    <span className={`cm-text-color mt-1 ps-2 ${props.isOpen ? '' : 'd-none'}`}>
                                        {item.title}
                                    </span>
                                </Nav.Link>
                            )}
                        </Nav.Item>
                    ))}

                </Nav>
            </div>
            {/* Offcanvas Sidebar */}
            <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasSidebar" aria-labelledby="offcanvasSidebarLabel">
                <div className="offcanvas-header">
                    <div className="offcanvas-title d-flex" id="offcanvasSidebarLabel">
                        {/* <BsPersonCircle className="text-danger me-1" size={24} /> */}
                        {/* <Nav.Link className="cm-text-color" href="#user">{localStorageObj?.username}</Nav.Link> */}
                        <div className="dropdown">
                            <div
                                className="d-flex align-items-center ms-3 text-cm-light-text cursor-pointer "
                                role="button"
                                data-bs-toggle="dropdown"
                            >
                                <BsPersonCircle className="text-black" size={24} />
                                <h6 className="mb-0 ms-2">
                                    {/* {currentUserData && currentUserData?.name} */}
                                    {localStorageObj?.username}
                                </h6>
                                <BsCaretDownFill className="text-black mt-1" />
                            </div>
                            <ul
                                className="dropdown-menu dropdown-menu-light"
                                aria-labelledby="navbarDropdownMenuLink"
                            >
                                <li onClick={() => navigate("/about")}>
                                    <a className="dropdown-item cursor-pointer">
                                        About Us
                                    </a>
                                </li>
                                <li onClick={handleResetClick}>
                                    <a className="dropdown-item cursor-pointer">
                                        Reset password
                                    </a>
                                </li>
                                <hr className="border-1 m-0 border-secondary" />
                                <li onClick={handleLogOut}>
                                    <a className="dropdown-item cursor-pointer">
                                        Sign out
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body">
                    <Nav defaultActiveKey="/home" className="flex-column">
                        {filteredSidebarData.map((item, index) => (
                            <Nav.Item key={index}>
                                {item.subNav ? (
                                    <>
                                        <Nav.Link
                                            className="d-flex align-items-center justify-content-between"
                                            onClick={() => toggleSubNav(index)}
                                        >
                                            <div className="text d-flex align-items-center">
                                                <span className="text-primary">{item.icon}</span>
                                                <span className={`ps-2 cm-text-color ${props.isOpen ? '' : 'd-none'}`}>
                                                    {item.title}
                                                </span>
                                            </div>
                                            <span className="text-primary">
                                                {open[index] ? <BsCaretUpFill /> : <BsCaretDownFill />}
                                            </span>
                                        </Nav.Link>

                                        {open[index] && (
                                            <Nav className="flex-column ms-3">
                                                {item.subNav.map((subItem: any, subIndex: any) => (
                                                    <div key={subIndex}>
                                                        {subItem.subNav ? (
                                                            <>
                                                                <Nav.Link
                                                                    className="d-flex align-items-center justify-content-between"
                                                                    onClick={() => toggleSubNav(`${index}-${subIndex}`)}
                                                                >
                                                                    <div className="text d-flex align-items-center">
                                                                        <span className="text-primary">{subItem.icon}</span>
                                                                        <span className={`ps-2 cm-text-color ${props.isOpen ? '' : 'd-none'}`}>
                                                                            {subItem.title}
                                                                        </span>
                                                                    </div>
                                                                    <span className="text-primary">
                                                                        {open[`${index}-${subIndex}`] ? <BsCaretUpFill /> : <BsCaretDownFill />}
                                                                    </span>
                                                                </Nav.Link>

                                                                {open[`${index}-${subIndex}`] && (
                                                                    <Nav className="flex-column ms-4">
                                                                        {subItem.subNav.map((langItem: any, langIndex: any) => (
                                                                            <Nav.Link as={Link} to={langItem.path} key={langIndex}>
                                                                                <span className="text-primary">{langItem.icon}</span>
                                                                                <span className={`ps-2 cm-text-color ${props.isOpen ? '' : 'd-none'}`}>
                                                                                    {langItem.title}
                                                                                </span>
                                                                            </Nav.Link>
                                                                        ))}
                                                                    </Nav>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <Nav.Link as={Link} to={subItem.path}>
                                                                <span className="text-primary">{subItem.icon}</span>
                                                                <span className={`ps-2 cm-text-color ${props.isOpen ? '' : 'd-none'}`}>
                                                                    {subItem.title}
                                                                </span>
                                                            </Nav.Link>
                                                        )}
                                                    </div>
                                                ))}
                                            </Nav>
                                        )}
                                    </>
                                ) : (
                                    <Nav.Link className="d-flex align-items-center" as={Link} to={item.path}>
                                        <span className="text-primary">{item.icon}</span>
                                        <span className={`cm-text-color mt-1 ps-2 ${props.isOpen ? '' : 'd-none'}`}>
                                            {item.title}
                                        </span>
                                    </Nav.Link>
                                )}
                            </Nav.Item>
                        ))}
                    </Nav>
                </div>
            </div>
            {resetPasswordShow && (
                <ForgotResetPassword
                    forgotResetShow={resetPasswordShow}
                    setForgotResetShow={setResetPasswordShow}
                    title={PAGE_TITLE.RESET_PASSWORD} />
            )}
        </>
    );
}

export default Sidebar;